import { render, staticRenderFns } from "./SpfiIndex.vue?vue&type=template&id=294d0f44"
import script from "./SpfiIndex.vue?vue&type=script&lang=js"
export * from "./SpfiIndex.vue?vue&type=script&lang=js"
import style0 from "./SpfiIndex.vue?vue&type=style&index=0&id=294d0f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports